import { updateObject } from "../../../../shared";
import {
  globalConstants,
  PAGINATION_DEFAULTS,
  featureFlagsReduxConstants,
} from "../../constants";

const { SUCCESS, FAILURE } = globalConstants;
const { GET_ALL_BRANDS_FOR_FEATURE_FLAGS } = featureFlagsReduxConstants;

// Start the brand list with the shared page defaults.
const initalState = {
  allBrandsForFeatureFlags: [],
  featureFlagsPagination: {
    ...PAGINATION_DEFAULTS,
  },
};
export const featureFlagsReducer = (state = initalState, action) => {
  switch (action.type) {
    case GET_ALL_BRANDS_FOR_FEATURE_FLAGS + SUCCESS:
      return updateObject(state, {
        allBrandsForFeatureFlags: action.data.data,
        featureFlagsPagination: action.data.page,
      });
    case GET_ALL_BRANDS_FOR_FEATURE_FLAGS + FAILURE:
      return updateObject(state, {
        allBrandsForFeatureFlags: initalState.allBrandsForFeatureFlags,
      });

    default:
      return state;
  }
};
